import { Config } from '@leverege/plugin';
export default {
  id: 'recovr.TagPairingValidation',
  type: 'recovr.TagPairingValidation',
  perform: async cxt => {
    const {
      setActiveStep,
      wizardData
    } = cxt;
    const {
      tag
    } = wizardData;
    try {
      // Check for activation status
      if (isTagUnactivated(tag?.obj)) {
        setActiveStep('tagUnactivated');
        return;
      }
      // Check for low battery
      if (isTagLowBattery(tag?.obj)) {
        setActiveStep('tagLowBattery');
        return;
      }
      // If all validations pass, continue to the summary
      setActiveStep('pairSummary');
    } catch (err) {
      // If there's an unexpected error, go to the default error screen
      setActiveStep('pairingError');
    }
  }
};

/**
 * Check if the tag's keystream device state shows the device as already been activated by checking if last heartbeat is not null
 * and is within the offline window (10 mins)
 */
function isTagUnactivated(tag) {
  const tagOfflineWindow = Config.get('Pairing', 'tagOfflineWindow', 1000 * 60 * 10);
  const lastHeartbeat = tag?.data?.data?.lastHeartbeat;
  return !lastHeartbeat || lastHeartbeat < Date.now() - tagOfflineWindow;
}

/**
 * Checks if the tag's battery level is below the 'low battery' threshold (50%).
 */
function isTagLowBattery(tag) {
  const batteryLevel = tag?.data?.data?.batteryLevel;
  return batteryLevel && batteryLevel < 50;
}